/* eslint-disable no-unused-vars */
import Swiper from 'swiper/js/swiper';
import '~/sass/pages/maintenance.scss';
import '~/sass/pages/electric-guarantee.scss';

const { $ } = window;

let swiperNewCar = null;
let swiperSpecPackages = null;
let swiperSpecPower = null;
let swiperAdvantage = null;
let swiperSpecUpgrade = null;
let swiperSteps = null;
let swiperLeading = null;

function navScrollToFixed() {
  let beltH = null;
  const wW = $(window).width();
  if (wW < 1024) {
    beltH = 50;
    $('body').attr('data-offset', beltH);
  } else {
    beltH = 60;
    $('body').attr('data-offset', 270);
  }

  $('#global-header').scrollToFixed({
    limit: $('#belt').offset().top - $('#global-header').height(),
    zIndex: 99999,
  });

  $('#belt').scrollToFixed();

  $('#belt a[href*="#"]').on('click', function Amooth() {
    const bW = $('#belt .slider').width();
    if (this.hash !== '') {
      const { hash } = this;

      $('#belt a[href*="#"]').removeClass('active');
      $(this).addClass('active');

      $('html, body').stop().animate({
        scrollTop: $(hash).offset().top - beltH + 5,
      }, 800,
      () => {
        if (window.history.pushState) {
          window.history.pushState(null, null, hash);
        } else {
          window.location.hash = hash;
        }
      });
      return false;
    }
  });
}

function mobileNavScroll() {
  const $navHoles = $('#belt .holes');
  const $navSelect = $('#belt .select');
  $('#belt .select').on('click', () => {
    if ($navHoles.hasClass('active')) {
      $navHoles.removeClass('active');
    } else {
      $navHoles.addClass('active');
    }
  });
  $('#belt .slider a').on('click', function clickLink() {
    const sectionName = $(this).text();
    $navHoles.removeClass('active');
    $navSelect.find('span').text(sectionName);
  });
  $(window).scroll(() => {
    const unitName = $('#belt .slider li a.active').text();

    if (unitName !== '') {
      $('#belt .select span').text(unitName);
    }
  });
}

function initNewCarSwipers() {
  const screenWidth = $(window).width();
  if (screenWidth < 1024 && swiperNewCar == null) {
    swiperNewCar = new Swiper('#newcar .swiper-container', {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 25,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: '#newcar .swiper-button-next',
        prevEl: '#newcar .swiper-button-prev',
      },
      breakpoints: {
        767: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 5,
          centeredSlides: false,
        },
      },
    });
  } else if (screenWidth >= 1024 && swiperNewCar != null) {
    swiperNewCar.destroy();
    swiperNewCar = null;
    $('#newcar .swiper-wrapper').removeAttr('style');
    $('#newcar .swiper-slide').removeAttr('style');
  }
}

function initSpecPackagesSwipers() {
  swiperSpecPackages = new Swiper('#sectionPackageIntroduction #spec-packages .swiper-container', {
    slidesPerView: 1.25,
    centeredSlides: true,
    spaceBetween: 25,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '#sectionPackageIntroduction #spec-packages .swiper-button-next',
      prevEl: '#sectionPackageIntroduction #spec-packages .swiper-button-prev',
    },
    breakpoints: {
      769: {
        slidesPerView: 2.25,
        slidesPerGroup: 2,
        centeredSlides: false,
      },
      1140: {
        slidesPerView: 3.25,
        slidesPerGroup: 3,
        centeredSlides: false,
      },
    },
  });
}

function initSpecPowerSwipers() {
  swiperSpecPower = new Swiper('#sectionPackageIntroduction #spec-power .swiper-container', {
    slidesPerView: 1.25,
    centeredSlides: true,
    spaceBetween: 25,
    observer: true,
    observeParents: true,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '#sectionPackageIntroduction #spec-power .swiper-button-next',
      prevEl: '#sectionPackageIntroduction #spec-power .swiper-button-prev',
    },
    breakpoints: {
      769: {
        slidesPerView: 2.25,
        slidesPerGroup: 2,
        centeredSlides: false,
      },
      1140: {
        slidesPerView: 3.25,
        slidesPerGroup: 3,
        centeredSlides: false,
      },
    },
  });
}

function initSpecUpgradeSwipers() {
  swiperSpecUpgrade = new Swiper('#sectionPackageIntroduction #spec-upgrade .swiper-container', {
    slidesPerView: 1.25,
    centeredSlides: true,
    spaceBetween: 25,
    observer: true,
    observeParents: true,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '#sectionPackageIntroduction #spec-upgrade .swiper-button-next',
      prevEl: '#sectionPackageIntroduction #spec-upgrade .swiper-button-prev',
    },
    breakpoints: {
      769: {
        slidesPerView: 2.25,
        slidesPerGroup: 2,
        centeredSlides: false,
      },
      1140: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        centeredSlides: false,
      },
    },
  });
}

function initAdvantageSwipers() {
  swiperAdvantage = new Swiper('#sectionMaintenanceBenefits .swiper-advantage .swiper-container', {
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 0,
    observer: true,
    observeParents: true,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '#sectionMaintenanceBenefits .swiper-advantage .swiper-button-next',
      prevEl: '#sectionMaintenanceBenefits .swiper-advantage .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        centeredSlides: false,
      },
      1140: {
        slidesPerView: 4,
        centeredSlides: false,
      },
    },
  });
}

function initStepsSwipers() {
  swiperSteps = new Swiper('#sectionPaintingService .swiper-steps .swiper-container', {
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 0,
    observer: true,
    observeParents: true,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '#sectionPaintingService .swiper-steps .swiper-button-next',
      prevEl: '#sectionPaintingService .swiper-steps .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 30,
      },
      1140: {
        slidesPerView: 6,
        centeredSlides: false,
        spaceBetween: 30,
      },
    },
  });
}

function initLeadingSwipers() {
  swiperLeading = new Swiper('#sectionPaintingService .swiper-leading .swiper-container', {
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 0,
    observer: true,
    observeParents: true,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '#sectionPaintingService .swiper-leading .swiper-button-next',
      prevEl: '#sectionPaintingService .swiper-leading .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 30,
      },
      1140: {
        slidesPerView: 5,
        centeredSlides: false,
        spaceBetween: 30,
      },
    },
  });
}

function paintingFancybox() {
  const fancyboxDefaults = {
    // smallBtn: true,
    // toolbar: false,
    buttons: [
      'close',
    ],
    touch: true,
    baseClass: 'figure-slide',
    infobar: false,
    animationEffect: 'fade',
    transitionEffect: 'slide',
    // eslint-disable-next-line consistent-return
    clickContent(current) {
      if (current.type === 'image') {
        return false;
      }
    },
    caption() {
      return $(this).find('figcaption').html();
    },
    btnTpl: {
      close:
        '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">'
        + '<i class="icon icon-close"></i>'
        + '</button>',
      arrowLeft:
        '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">'
        + '<i class="icon icon-nav-arrow"></i>'
        + '</button>',
      arrowRight:
        '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">'
        + '<i class="icon icon-nav-arrow"></i>'
        + '</button>',
    },
    // eslint-disable-next-line no-unused-vars
    onInit(instance, current) {
      // console.log(instance)
      if ($.fancybox.isMobile) {
        const a = $('body,html').scrollTop() * -1;
        $('body,html').css('top', a).addClass('fancybox-iosfix');
        // console.log(a)
      }
    },
    afterClose() {
      let offset;
      if ($('body,html').hasClass('fancybox-iosfix')) {
        offset = parseInt(document.body.style.top, 10);
        $('body,html').removeClass('fancybox-iosfix').css('top', '').scrollTop(offset * -1);
      }
    },
  };
  $('[data-fancybox="YTvideo"]').fancybox(fancyboxDefaults);
}

$(document).ready(() => {
  navScrollToFixed();
  mobileNavScroll();
  initNewCarSwipers();
  initSpecPackagesSwipers();
  initSpecPowerSwipers();
  initSpecUpgradeSwipers();
  initAdvantageSwipers();
  initStepsSwipers();
  initLeadingSwipers();

  $(window).on('resize', () => {
    initNewCarSwipers();
  });

  $('#details30').fancybox({
    baseClass: 'fancybox-container-modal',
    touch: false,
  });
  $('#details50').fancybox({
    baseClass: 'fancybox-container-modal',
    touch: false,
  });
  $('#details60').fancybox({
    baseClass: 'fancybox-container-modal',
    touch: false,
  });

  paintingFancybox();
});
